import firebase from "firebase";
import { store } from "../../../redux";
import { addAddress, addWallet, customerSearch, fetchCustomer, fetchSavedAddresses, save, fetchAllCustomers, createCustomer, updateCustomer, deleteCustomer, fetchCustomerOrders, debugOrdersStructure, searchCustomers, filterAllCustomers } from "../services/customer.services";
import { actions as customerActions } from "../stores/customer.store"
import { CUSTOMER_STORE_NAME } from "../../../contants/stores";

export const getCustomerById = (id: string) => {
  try {
    return fetchCustomer(id, {
      listeners: {
        onUpdate: (res: any) => {
          console.log('updated', { ...res })
          store.dispatch(customerActions.setCustomer({ ...res }));
        },
      },
    });
  } catch (error) {
    console.log('get-customer', error)
  }
}

export const getSavedAddressesById = async (id: string) => {
  try {
    const docs = await fetchSavedAddresses(id);
    store.dispatch(customerActions.setSavedAddresses(docs));
  } catch (error) {
    console.log('getSavedAddressesById', error)
  }
}

export const addNewAddress = async (id: string, address: any) => {
  try {
    addAddress(id, address);
  } catch (error) {
    console.log('addNewAddress', error)
  }
}

export const searchCustomerByPhone = async(phone: string) => {
  try {
    return customerSearch(phone, {
      listeners: {
        onUpdate: (res: any) => {
          store.dispatch(customerActions.setSearchCustomer({...res}));
        },
      },
    });
  } catch (error) {
    console.log('searchCustomerByPhone: ', error);
  }
}

export const close = () => {
  store.dispatch(customerActions.setSearchCustomer({}));
}

export const updateTags = async (id: string, tags: string[]) => {
  try {
    await save(id, {
      tags,
    });
  } catch (error) {
    console.log('updateTags', error)
  }
}

export const addWalletEntry = async (id: string, amount: number, reason: string) => {
  try {
    const entry = {
      amount: Math.abs(amount), 
      reason: reason,
      type: amount > 0 ? "IN" : "OUT",
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    }
    await addWallet(id, entry);

  } catch (error) {
    console.log('addWallet', error)
  }
}

export const getAllCustomers = async (limit?: number, offset?: number) => {
  try {
    const customers = await fetchAllCustomers(limit, offset);
    store.dispatch(customerActions.setCustomers(customers));
  } catch (error) {
    console.log('getAllCustomers', error)
  }
}

export const filterAllCustomersAction = async (filters: {
  status?: string;
  walletMin?: number;
  walletMax?: number;
  createdFrom?: string;
  createdTo?: string;
}) => {
  try {
    console.log("Filtering all customers with filters:", filters);
    
    // Check if any filters are actually set
    const hasActiveFilters = Object.values(filters).some(value => 
      value !== undefined && value !== null && value !== '' && value !== 'ALL'
    );
    
    if (!hasActiveFilters) {
      // If no filters are active, revert to paginated fetch
      await getAllCustomers(10, 0);
      return;
    }
    
    const customers = await filterAllCustomers(filters, 1000);
    store.dispatch(customerActions.setCustomers(customers));
    console.log("Filter completed, found customers:", customers.length);
  } catch (error) {
    console.log('filterAllCustomersAction', error);
  }
}

export const searchAllCustomers = async (searchQuery: string) => {
  try {
    console.log("Searching all customers with query:", searchQuery);
    
    if (!searchQuery || searchQuery.trim().length === 0) {
      // If search is empty, revert to paginated fetch
      await getAllCustomers(10, 0);
      return;
    }
    
    const customers = await searchCustomers(searchQuery, 50);
    store.dispatch(customerActions.setCustomers(customers));
    console.log("Search completed, found customers:", customers.length);
  } catch (error) {
    console.log('searchAllCustomers', error);
  }
}

export const updateQuery = (query: string) => {
  store.dispatch(customerActions.updateSearchQuery(query));
}

export function search(query: string) {
  const customers = store.getState()[CUSTOMER_STORE_NAME].customers;
  
  return customers.filter((customer: any) => {
    return (
      (customer.name && customer.name.toLowerCase().includes(query.toLowerCase())) || 
      (customer.email && customer.email.toLowerCase().includes(query.toLowerCase())) || 
      (customer.phone && customer.phone.toLowerCase().includes(query.toLowerCase())) ||
      (customer.id && customer.id.toLowerCase().includes(query.toLowerCase()))
    );
  });
}

export const createNewCustomer = async (customerData: any) => {
  try {
    const customerId = await createCustomer(customerData);
    
    // Since we're simulating the creation, we'll add the customer to the local state
    // This provides immediate UI feedback while the actual database write is pending
    const customers = store.getState()[CUSTOMER_STORE_NAME].customers;
    const newCustomer = {
      id: customerId,
      ...customerData,
      createdAt: new Date(),
      isDeleted: false
    };
    
    // Add to local state for immediate UI update
    store.dispatch(customerActions.setCustomers([newCustomer, ...customers]));
    
    console.log('Customer created successfully (simulated):', customerId);
  } catch (error) {
    console.log('createNewCustomer', error);
    throw error;
  }
}

export const updateExistingCustomer = async (id: string, customerData: any) => {
  try {
    await updateCustomer(id, customerData);
    
    // Update the customer in local state for immediate UI feedback
    const customers = store.getState()[CUSTOMER_STORE_NAME].customers;
    const updatedCustomers = customers.map((customer: any) => 
      customer.id === id ? { ...customer, ...customerData, updatedAt: new Date() } : customer
    );
    
    store.dispatch(customerActions.setCustomers(updatedCustomers));
    
    console.log('Customer updated successfully (simulated):', id);
  } catch (error) {
    console.log('updateExistingCustomer', error);
    throw error;
  }
}

export const deleteExistingCustomer = async (id: string) => {
  try {
    await deleteCustomer(id);
    // Refresh the customers list
    await getAllCustomers();
  } catch (error) {
    console.log('deleteExistingCustomer', error);
    throw error;
  }
}

export const getCustomerOrders = (customerId: string, customerPhone: string) => {
  try {
    return fetchCustomerOrders(customerId, customerPhone, {
      listeners: {
        onGetAll: (res: any) => {
          console.log('Customer orders loaded:', res.orders?.length);
          store.dispatch(customerActions.setCustomerOrders(res.orders || []));
        },
      },
    });
  } catch (error) {
    console.log('getCustomerOrders', error)
  }
}

export const debugOrders = async () => {
  try {
    await debugOrdersStructure();
  } catch (error) {
    console.log('debugOrders', error)
  }
}

